import { defineStore } from 'pinia'

export const useLohndatenStore = defineStore('lohndaten', {
  state: () => {

    return {
      iscCode: null,
      beruf: null,
      branche: null,
      age: 37,
      experience: 10,
      ausbildung: null,
      stunden: 40,
      stellung: null,
      is_lead: null,
      onrp: null,
      contact: {
        first_name: '',
        last_name: '',
        email: ''
      }
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        storage: window.localStorage
      }
    ]
  }
})

export const useResultStore = defineStore('result', {
  state: () => ({
    result: {
      p25: -1,
      p50: -1,
      p75: -1,
      n: -1,
      firms: -1,
      regionId: -1
    },
    state: null,
    errors: {},
    request: {},
    is_national: false
  }),
  persist: {
    enabled: true,
    strategies: [
      {
        storage: window.localStorage
      }
    ]
  }
})

export const useGAVStore = defineStore('gav', {
  state: () => ({
    branche: null,
    onrp: null,
    selected: [],
    answers: {},
    result: null,
    specialCases: {},
  }),
  persist: {
    enabled: true,
    strategies: [
      {
        storage: window.localStorage
      }
    ]
  }
})
